import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { inZone } from '../utils/companyDate';

// Settings > Account, the owner's own choice about SnowTrack product email
// (migration 111; server/services/marketingEmail.js). Owners only: Settings
// renders it for the owner, and PUT /api/auth/marketing refuses anyone else.
// It saves as soon as the box changes; there is no Save button.

export const PRODUCT_EMAIL_LABEL = 'Email me SnowTrack product news, tips and offers';

function ProductEmailCard({ user, timezone, onSaved }) {
  const [optIn, setOptIn] = useState(Boolean(user?.marketingOptIn));
  const [since, setSince] = useState(user?.marketingOptedInAt || null);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setOptIn(Boolean(user?.marketingOptIn));
    setSince(user?.marketingOptedInAt || null);
  }, [user?.marketingOptIn, user?.marketingOptedInAt]);

  const change = async (e) => {
    const next = e.target.checked;
    setSaving(true);
    setMessage('');
    setError('');
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/auth/marketing`, { optIn: next });
      setOptIn(res.data.marketingOptIn);
      setSince(res.data.marketingOptedInAt || null);
      setMessage(res.data.marketingOptIn ? 'Product email is on.' : 'Product email is off.');
      if (onSaved) onSaved();
    } catch (err) {
      setError(err.response?.data?.error || 'Could not save your choice. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const sinceText = optIn && since
    ? new Date(since).toLocaleDateString('en-US', inZone(timezone, { year: 'numeric', month: 'long', day: 'numeric' }))
    : null;

  return (
    <div className="card mb-lg">
      <div className="card-header">
        <h2 className="card-title">Product Email</h2>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      {message && <div className="alert alert-success">{message}</div>}
      <label htmlFor="marketingOptInToggle" style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', cursor: 'pointer' }}>
        <input
          type="checkbox"
          id="marketingOptInToggle"
          checked={optIn}
          onChange={change}
          disabled={saving}
          style={{ marginTop: '3px' }}
        />
        <span>{PRODUCT_EMAIL_LABEL}</span>
      </label>
      <p className="text-muted" style={{ fontSize: '0.875rem', marginTop: '8px' }}>
        {sinceText ? `On since ${sinceText}. ` : ''}
        Sent to your login email. Every message has an unsubscribe link. Account email, such as password resets and billing notices, is not affected.
      </p>
    </div>
  );
}

export default ProductEmailCard;
